(function() {
    document.addEventListener('offerlyOfferSubmitted', (event) => {
        console.log('offer submitted...updating url');

        const off_url = new URL(window.location.href);

        // Add query params
        off_url.searchParams.set('offerly_submitted', 'true');

        // Update off_url without reload
        window.history.replaceState({}, '', off_url.toString());
    });
})();
